import styles from './Filters.less';

import React, { PropTypes, Component } from 'react';
import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import { sortModeViewModel } from '@seek/seek-refine-job-search';

import LinkSelect from 'LinkSelect/LinkSelect';
import { sortModeChanged } from 'store/search/search';

const sortModeViewModelSelector = () => createSelector(
  state => state.search.query,
  state => state.results.sortMode,

  (searchQuery, sortMode) => ({
    sortModeOptions: sortModeViewModel({ searchQuery, sortMode })
  })
);

function mapDispatchToProps(dispatch) {
  return {
    onSortModeChange: () => dispatch(sortModeChanged())
  };
}

@connect(sortModeViewModelSelector, mapDispatchToProps)
class Filters extends Component {

  static propTypes = {
    sortModeOptions: PropTypes.array,
    onSortModeChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    sortModeOptions: null
  };

  render() {
    const { sortModeOptions, onSortModeChange } = this.props;

    return (
      <div className={styles.root}>
        {
          !sortModeOptions ? null : (
            <LinkSelect id="sortModeFilter" label="Sorted by" options={sortModeOptions} onChange={onSortModeChange} />
          )
        }
      </div>
    );
  }

}

export default Filters;



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/SearchResultSummary/components/Filters/Filters.js
 **/